<script setup lang="ts"></script>

<template>
  <div v-if="$slots.preview" class="px-3 pt-2 pb-0">
    <slot name="preview" />
  </div>

  <div class="px-3 py-2">
    <slot name="colors" />
  </div>

  <v-divider color="outline-variant" />

  <slot name="actions" />
</template>

<style scoped lang="scss"></style>
